/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useParams} from "react-router";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/* Helpers, constants, custom methods, internal libraries */
import { usePeopleService } from "../../services/peopleService";
import { useGlobalContext, useGlobalUpdateContext } from "../../contexts/globalContext";
import { colors } from "../../constants/colors";
import {useHasPermission} from "../../hooks/useHasPermission";
import { PEOPLE_ROUTE, PEOPLE_TEAMS_ROUTE } from "../../constants/routes";
import { Link } from 'react-router-dom';


/* Components */
import UCButton from "../../components/buttons";
import EditTeamModal from "../modals/editTeamModal";
import DeleteTeamModal from "../modals/deleteTeamModal";
import DeleteDefaultTeamModal from "../modals/deleteDefaultTeamModal";
import Breadcrumbs from "../../components/breadcrumbs";

/* Styles */
import styles from "./styles.js"


const TeamDetailsHeader = ({ teamDetails, editTeam, setDefaultTeam }) => {
  let { teamId } = useParams();
  const theme = useTheme();
  const classes = styles({ theme });

  const globalProperties  = useGlobalContext();
  const setGlobalProperties  = useGlobalUpdateContext();
  const { checkPermission } = useHasPermission();

  const { getSharedLink } = usePeopleService();
  const [showEditTeamModal, setShowEditTeamModal] = useState(false);
  const [showDeleteTeamModal, setShowDeleteTeamModal] = useState(false);
  const [showDeleteDefaultTeamModal, setShowDeleteDefaultTeamModal] = useState(false);

  const handleModalClick = async () =>{
    const response = await getSharedLink(teamId);

    if (response) {
      setGlobalProperties({
        ...globalProperties,
        invitePeopleModal: {
          showInvitePeopleModal: true,
          teamName: response.teamName,
          sharedLink: response.sharedLink,
          active: response.active,
          requiresDomain: response.requiresDomain,
          teamId: teamId,
          isNotDefault: !teamDetails?.default
        }
      })
    }
  }

  const handleEditTeamModalClick = () =>{
    setShowEditTeamModal(true)
  }

  return (
    <div className={classes.peoplePageHeader}>
      <Breadcrumbs
        items={[
          <Link to={PEOPLE_ROUTE}>
            <FormattedMessage id="breadcrumbs.people"/>
          </Link>,
          <Link to={PEOPLE_TEAMS_ROUTE}>
            <FormattedMessage id="breadcrumbs.teams"/>
          </Link>,
          teamDetails?.groupName
        ]}
      />
      <Container className={classes.container}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={6} className="gx-0">
            <div className={classes.titleWrapper}>
              <h1 className={classes.title}>
                { teamDetails?.groupName }
              </h1>
              { teamDetails?.default && <div className={classes.defaultBadge}><FormattedMessage id="team.details.defaultTeamBadge"/></div> }
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12} xl={6} className="px-2">
            <div className={classes.actions}>
              {
                checkPermission("F_EDIT_GROUP_DEFAULTGROUP") &&
                  <UCButton
                    type="general"
                    className={teamDetails?.default ? classes.makeDefaultDisabledBtn : classes.makeDefaultBtn}
                    text={<FormattedMessage id="team.details.makeDefaultTeam"/>}
                    onClick={() => setDefaultTeam(teamId)}
                    spinner={{
                      name: "setDefaultTeamSpinner",
                      size: 20,
                    }}
                  />
              }
              <div className={classes.btnsDiv}>
                {
                  checkPermission("F_EDIT_GROUP") &&
                    <UCButton
                      type="default"
                      className={classes.pendingInvitesBtn}
                      text={<FormattedMessage id="team.details.edit"/>}
                      onClick={() => handleEditTeamModalClick()}
                    />
                }
                {
                  checkPermission("F_INVITE_USER") &&
                    <UCButton
                      type="primary"
                      className={classes.invBtn}
                      onClick={() => handleModalClick()}
                      text={<FormattedMessage id="people.inviteButton"/>}
                      spinner={{
                        name: "invitePeopleButton",
                        size: 20,
                      }}
                    />
                }
              </div>
            </div>
          </Col>
        </Row>
        <EditTeamModal
          showEditTeamModal={showEditTeamModal}
          setShowEditTeamModal={setShowEditTeamModal}
          setShowDeleteTeamModal={setShowDeleteTeamModal}
          setShowDeleteDefaultTeamModal={setShowDeleteDefaultTeamModal}
          isDefault={teamDetails?.default}
          teamName={teamDetails?.groupName}
          teamId={teamId}
          editTeam={editTeam}
        />
        <DeleteTeamModal
          showDeleteTeamModal={showDeleteTeamModal}
          setShowDeleteTeamModal={setShowDeleteTeamModal}
          teamId={teamId}
          teamName={teamDetails?.groupName}
        />
        <DeleteDefaultTeamModal
          showDeleteDefaultTeamModal={showDeleteDefaultTeamModal}
          setShowDeleteDefaultTeamModal={setShowDeleteDefaultTeamModal}
        />
      </Container>
    </div>
  )
}

export default TeamDetailsHeader;
